var map = {
	"./tokenBox21.png": "9926",
	"./tokenBox22.png": "3afd",
	"./tokenBox23.png": "3ca7",
	"./tokenBox24.png": "599b",
	"./tokenBox25.png": "38a5",
	"./tokenBox26.png": "c2f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4715";